import React from 'react';
import uuid from '../../../core/components/UniqueHash';
import { useModal } from '../../../../../hooks/Modal';

import api from '../../../../../services/api';
import { useToast } from '../../../../../hooks/Toast';
import { useSearch } from '../../../../../hooks/Search';
import { FaDownload, FaEdit, FaNewspaper, FaUpload } from 'react-icons/fa';
 
import { useLoading } from '../../../../../hooks/LoadingHook';
import { urlWebsite } from '../../../../../config';

function extFromUrl(url: string): string | undefined {
 const value = url?.toLowerCase();

 const str = value.split('.');

 return str?.[str?.length -1];
}

export default function UpdateModule({lineData}): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();
  const {addLoading, removeLoading} = useLoading();
  const key = uuid();

  const uploadContacts = async ( ) => {

 



 
/* get all papers from this rules */
 const paperList =   await api.get(`/cientific-submissions`, { params: { limitItems: 10000, where: { cientific_selective_id : lineData?._id?.toString()}}} );
 const papers = paperList?.data?.rows;
 
 /* complete with a function that gets presentation_image from each paper and download it giving the file-name as paper.title + author)
 
 before download, check if is an image or pdf
 
 */
let x = 0;
while( x < papers?.length){

  const paper = papers[x];

  if(paper?.presentation_image){
 try{
            const response = await api.get(`${urlWebsite}/${paper?.presentation_image}`,{  
             
              responseType: 'arraybuffer',
          }) 
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${paper?.title}-${paper?.author}.${extFromUrl(paper?.presentation_image)}`);
            document.body.appendChild(link);
            link.click();
 



}
catch(err){
 
  addToast({title:'Erro ao baixar arquivos', type:'error'})
  
}
  }

  x +=1;
}
 
  }
 

  const moduleUpdate = (): JSX.Element => (
    <button className="lineIcon" title="Baixar papers" type="button" onClick={() => uploadContacts()}>
      <FaDownload />
    </button>
  );

  return moduleUpdate();
}
